import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";

import { Generic, Column, Button } from "rbx";

import { useQuery } from "react-apollo";

import { ModalContext } from "../../../../components/ModalProvider";

import { SINGLE_ROUTE_QUERY } from "../../../../graphql/Routes/Routes.graphql";

import { OrderSpecialInstructionsForm } from "../../../../components/Orders";

import { LocationSelect } from "../../../../components/inputs";

const LocationInfo = ({
  label,
  locationSI,
  locationSIName,
  locationRecId,
  locationRecIdName,
  onChange,
  editing,
  adding,
  needBeChanged
}) => {
  const { setModalOpen } = useContext(ModalContext);
  return (
    <LocationSelect
      addons={
        <Button
          className="location-select-addon"
          color="primary"
          disabled={!adding && !editing}
          tooltip={
            locationSI || "There are no special instructions for this location."
          }
          onClick={() =>
            setModalOpen(
              true,
              <OrderSpecialInstructionsForm
                label={label}
                name={locationSIName}
                value={locationSI}
                onChange={onChange}
                onClose={() => setModalOpen(false, "")}
              />
            )
          }
        >
          <Generic textColor={locationSI ? "link" : "grey"} textWeight="bold">
            SI
          </Generic>
        </Button>
      }
      disabled={!editing}
      label={label}
      name={locationRecIdName}
      needBeChanged={needBeChanged}
      value={locationRecId}
      onChange={onChange}
    />
  );
};
LocationInfo.propTypes = {
  label: PropTypes.string,
  locationRecId: PropTypes.string,
  locationSI: PropTypes.string,
  locationSIName: PropTypes.string,
  locationRecIdName: PropTypes.string,
  onChange: PropTypes.func,
  editing: PropTypes.bool,
  adding: PropTypes.bool,
  needBeChanged: PropTypes.object
};

function Locations({ adding, order, editing, onChange }) {
  const [, setRoute] = useState(order?.Route ? { ...order.Route } : {});
  const { data } = useQuery(SINGLE_ROUTE_QUERY, {
    variables: {
      where: {
        RecId: order?.RouteRecIdRef ? parseInt(order.RouteRecIdRef) : null
      }
    }
  });

  useEffect(() => {
    if (data && data.Route) {
      setRoute(data.Route);
    }
  }, [data, onChange]);
  return (
    <div className="order-tab-container location">
      <Column.Group>
        <Column>
          <LocationInfo
            adding={adding}
            editing={editing}
            label="Start Location"
            locationRecId={order.StartLocationRecIdRef}
            locationRecIdName="StartLocationRecIdRef"
            locationSI={order.StartLoc_SI}
            locationSIName="StartLoc_SI"
            onChange={onChange}
          />
        </Column>
        <Column>
          <LocationInfo
            adding={adding}
            editing={editing}
            label="Pickup Location"
            locationRecId={order.PickupLocationRecIdRef}
            locationRecIdName="PickupLocationRecIdRef"
            locationSI={order.PickupLoc_SI}
            locationSIName="PickupLoc_SI"
            needBeChanged={order.PickupLocation}
            onChange={onChange}
          />
        </Column>

        <Column>
          <LocationInfo
            adding={adding}
            editing={editing}
            label="Delivery Location"
            locationRecId={order.DeliveryLocationRecIdRef}
            locationRecIdName="DeliveryLocationRecIdRef"
            locationSI={order.DeliveryLoc_SI}
            locationSIName="DeliveryLoc_SI"
            needBeChanged={order.DeliveryLocation}
            onChange={onChange}
          />
        </Column>

        <Column>
          <LocationInfo
            adding={adding}
            editing={editing}
            label="Ending Location"
            locationRecId={order.EndingLocationRecIdRef}
            locationRecIdName="EndingLocationRecIdRef"
            locationSI={order.EndLoc_SI}
            locationSIName="EndLoc_SI"
            onChange={onChange}
          />
        </Column>
      </Column.Group>
    </div>
  );
}

Locations.propTypes = {
  order: PropTypes.object,
  onChange: PropTypes.func,
  editing: PropTypes.bool,
  adding: PropTypes.bool
};
Locations.defaultProps = {
  order: {},
  onChange: data => console.log(data)
};
export default Locations;
